<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { navigate } from 'svelte-routing';
  import { selectedCountry } from '../countryStore';
  import { t } from '../i18nStore';

  let banners = [];
  let isLoading = true;

  onMount(async () => {
      try {
          const res = await fetch(getApiUrl(`/banners?countryCode=${$selectedCountry}`));
          if (res.ok) {
              banners = await res.json();
          }
      } catch (e) {
          console.error("Failed to fetch banners", e);
      } finally {
          isLoading = false;
      }
  });

  // Removed the 'event' parameter; we completely control the flow now
  function handleBannerClick(banner) {
      const criteria = banner.searchCriteria || {};
      
      const searchState = {
          nameQuery: criteria.keyword || '',
          selectedCategories: criteria.categories || [],
          selectedStores: criteria.stores || [], 
          selectedMethods: [],
          bankQuery: [],
          selectedCreditCards: [],
          isOnline: false,
          isInStore: false,
          spendingQuery: ''
      };
      
      // 1. Save to session storage safely
      sessionStorage.setItem('promoSearchState', JSON.stringify(searchState));
      
      // 2. ONLY navigate after saving is complete
      navigate('/search');
  }
</script>

<div class="banners-section">
  {#if isLoading}
      <div class="loading-skeleton">{$t('banners.loading') || 'Loading featured offers...'}</div>
  {:else if banners.length > 0}
      <div class="banners-container">
          {#each banners as banner}
              <!-- FIX: Replaced <a> with an interactive <div> to prevent router race conditions -->
              <div 
                  class="banner-card {banner.width}" 
                  role="button"
                  tabindex="0"
                  on:click={() => handleBannerClick(banner)}
                  on:keydown={(e) => e.key === 'Enter' && handleBannerClick(banner)}
              >
                  <img src={banner.imageUrl} alt={banner.name} />
              </div>
          {/each}
      </div>
  {/if}
</div>

<style>
  .banners-section {
      margin: 2rem 0;
      padding: 0 1rem;
  }
  
  .banners-container {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
  }
  
  .banner-card {
      display: block;
      cursor: pointer;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 10px rgba(0,0,0,0.05);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      flex-grow: 0;
      background: #f4f4f4;
      text-decoration: none;
      outline: none; /* Prevents ugly blue border on click, relies on box-shadow for focus state if needed */
  }
  
  .banner-card:hover, .banner-card:focus {
      transform: translateY(-3px);
      box-shadow: 0 8px 15px rgba(0,0,0,0.1);
  }
  
  .banner-card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
  }

  /* Responsive Desktop Widths */
  .banner-card.full { width: 100%; }
  .banner-card.half { width: calc(50% - 0.5rem); }
  .banner-card.quarter { width: calc(25% - 0.75rem); }

  /* Tablet Responsiveness */
  @media (max-width: 992px) {
      .banner-card.quarter { width: calc(50% - 0.5rem); }
  }
  
  /* Mobile Responsiveness (All banners stack full width) */
  @media (max-width: 600px) {
      .banner-card.half, .banner-card.quarter { width: 100%; }
  }
  
  .loading-skeleton {
      height: 200px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: loading 1.5s infinite;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-weight: bold;
  }
  
  @keyframes loading {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
  }
</style>